import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'

import SpinerVeye from '../../../../../components/spinnerVeye/spinnerVeye'
import { api_google } from '../../../../../conexoes/google'
import { GOOGLE_MAPS_GEOCODING_API } from '../../../../../utils/googleMapsApiKey'
import Mapa from '../../../../googleMap/googleMapSemInfo'

export default function DadosCliente(props) {
  const [spinAtivo, setSpinAtivo] = useState(false)
  const [dadosMapa, setDadosMapa] = useState(null)
  const [semLocalizacao, setSemLocalizacao] = useState(false)

  const localTema = localStorage.getItem('tema')

  const {
    logradourocliente,
    bairrocliente,
    cidadecliente,
    ufcliente,
    cepcliente,
    emailVendedorCliente,
    telefoneVendedorCliente
  } = props

  useEffect(() => {
    async function geoCodeEndereco() {
      if (logradourocliente && cidadecliente) {
        setSemLocalizacao(false)
        setSpinAtivo(true)
        try {
          const enderecoFormatado =
            `${logradourocliente}, ${cidadecliente}, BR`.replace(/ /g, '+')
          const { data } = await api_google.get(
            `/geocode/json?address=${enderecoFormatado}&key=${GOOGLE_MAPS_GEOCODING_API}`
          )
          if (data.results.length > 0) {
            setDadosMapa(data.results[0].geometry.location)
          }
        } catch (error) {
          console.error('Erro ao buscar localização:', error)
        } finally {
          setSpinAtivo(false)
        }
      } else setSemLocalizacao(true)
    }

    geoCodeEndereco()
  }, [logradourocliente, cidadecliente])

  return (
    <Form>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}

      <div className="container-dados-cliente-novo">
        <div className="container-dados-cliente-wrapper">
          <div
            className={
              localTema === 'claro' ? 'dados-cliente' : 'dados-cliente-noturno'
            }
          >
            <div className="dados-cliente-cadastro">
              <div
                className={
                  localTema === 'claro'
                    ? 'cadastro-label'
                    : 'cadastro-label-noturno'
                }
              >
                Cadastro
              </div>
              <div
                className={
                  localTema === 'claro'
                    ? 'cadastro-content'
                    : 'cadastro-content-noturno'
                }
              >
                <div className="cadastro-content-text">
                  Endereço: {logradourocliente || '-'}
                </div>
                <div className="cadastro-content-text">
                  Estado: {ufcliente || '-'}
                </div>
                <div className="cadastro-content-text">
                  CEP: {cepcliente || '-'}
                </div>
                <div className="cadastro-content-text">
                  Bairro: {bairrocliente || '-'}
                </div>
                <div className="cadastro-content-text">
                  Cidade: {cidadecliente || '-'}
                </div>
              </div>
            </div>

            <div className="dados-cliente-contato">
              <div
                className={
                  localTema === 'claro'
                    ? 'cadastro-label'
                    : 'cadastro-label-noturno'
                }
              >
                Contato
              </div>
              <div
                className={
                  localTema === 'claro'
                    ? 'cadastro-content border-none'
                    : 'cadastro-content-noturno border-none'
                }
              >
                <div className="cadastro-content-text">
                  Telefone: {telefoneVendedorCliente || '-'}
                </div>
                <div className="cadastro-content-text">
                  E-mail: {emailVendedorCliente || '-'}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-dados-cliente-mapa-wrapper">
          <div
            className={
              localTema === 'claro'
                ? 'caixa-mapa-background'
                : 'caixa-mapa-background-noturno'
            }
          >
            <div
              className={
                dadosMapa
                  ? 'caixa-mapa'
                  : 'caixa-mapa-sem-localizacao fonte-cor-1'
              }
            >
              {semLocalizacao && (
                <div>Não foi possível encontrar dados de localização.</div>
              )}
              {dadosMapa && !semLocalizacao && (
                <Mapa array={dadosMapa} tipo="localizacao" />
              )}
            </div>
          </div>
        </div>
      </div>
    </Form>
  )
}
